module.exports = __webpack_public_path__ + "static/media/Hangar_Door_01.1e050a10.jpg";